import { Button, Flex, Typography } from "antd"
import { VideoCameraOutlined } from "@ant-design/icons"
import { isTemplateMediaUrl } from "~/common/videoTemplate/config"
import { useResourceUploadStatus } from "~/components/ResourceUploadField/UploadScope"
import { MediaField } from "./MediaFields"
import { useDownloadVideo } from "./useDownloadVideo"

export const DownloadVideoField = ({
  src,
  value,
  disabled,
  onChange,
}: {
  src: string
  value: string
  disabled: boolean
  onChange: (url: string) => void
}) => {
  const { stage, pending, error, generate, cancel } = useDownloadVideo(
    src,
    value,
    onChange,
  )
  const uploads = useResourceUploadStatus()
  return (
    <Flex
      vertical
      gap={8}
      data-testid="template-download-video"
    >
      <MediaField
        type="video"
        value={value}
        onChange={onChange}
      />
      <Flex
        align="center"
        gap={8}
        wrap
      >
        <Button
          icon={<VideoCameraOutlined />}
          loading={pending}
          disabled={
            disabled || uploads.pending || !isTemplateMediaUrl(src.trim())
          }
          onClick={() => void generate()}
        >
          {stage === "generating"
            ? "正在添加水印…"
            : stage === "uploading"
              ? "正在上传视频…"
              : "生成加水印视频"}
        </Button>
        {pending && <Button onClick={cancel}>取消生成</Button>}
      </Flex>
      {!src.trim() && (
        <Typography.Text type="secondary">请先配置案例视频。</Typography.Text>
      )}
      {error && (
        <Typography.Text
          type="danger"
          role="alert"
        >
          {error}
        </Typography.Text>
      )}
    </Flex>
  )
}
